import { useEffect } from "react";
import { tg } from "../telegram";

/**
 * Show Telegram's native BackButton while the component is mounted.
 * The button is automatically hidden on unmount.
 *
 * Pass an `onBack` callback that fires when the user taps the back button.
 *
 * Usage:
 *   useTelegramBackButton(() => navigate(-1));
 *   useTelegramBackButton(closeModal, [closeModal]);
 */
export function useTelegramBackButton(
  onBack: () => void,
  deps: React.DependencyList = [],
): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const t = tg();
    if (!t) return;
    t.BackButton.onClick(onBack);
    t.BackButton.show();
    return () => {
      t.BackButton.offClick(onBack);
      t.BackButton.hide();
    };
  }, deps);
}
